function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-chauffeEau");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-chauffeEau"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  fill: "#FFFFFF",
  x: 10,
  y: 7,
  width: 10,
  height: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,1 C17.6666667,1 20.3333333,1.66666667 23,3 L23,27 C20.3333333,28.3333333 17.6666667,29 15,29 C12.3333333,29 9.66666667,28.3333333 7,27 L7,3 C9.66666667,1.66666667 12.3333333,1 15,1 Z M15,9 C12.3333333,12.5294199 11,15.0894199 11,16.68 C11,19.0658701 12.790861,21 15,21 C17.209139,21 19,19.0658701 19,16.68 C19,15.0894199 17.6666667,12.5294199 15,9 Z",
  id: "Combined-Shape",
  fill: "#D93252"
})));

const SvgIco30ChauffeEau = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30ChauffeEau, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-chauffeEau.50d6e32b.svg";
export { ForwardRef as ReactComponent };